module.exports = __webpack_public_path__ + "static/images/cover_C6.fc644cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cover/cover_C6.png
// module id = p1xw
// module chunks = 8